export const EVENT_NAME = "Beach Fest"
export const EVENT_DESCRIPTION = "Presented by Pudgy Penguins & My Neighbor Alice"
export const SOCIAL_TAP_POINT_REWARD = 1

export const ENABLE_SHOP = false

export const CHANNELS = [
	{ name: "twitter", label: "Twitter" },
	{ name: "telegram", label: "Telegram" },
	{ name: "instagram", label: "Instagram" },
] as const

export function getSocialChannelUrl(
	handle: string,
	channelName: string,
): string {
	switch (channelName) {
		case "twitter":
			return `https://twitter.com/${handle}`
		case "telegram":
			return `https://t.me/${handle}`
		case "instagram":
			return `https://instagram.com/${handle}`
		default:
			console.warn(`missing social channel url config for: ${channelName}`)
			return ""
	}
}

export const ENABLE_FRIEND_CONNECTIONS = false

export const COLLECT_WALLETS = false

export const CONNECTION_TERMS = {
    connection: "friend",
    pendingConnection: "friend request",
	connectAction: {
		currentTense: "share",
		pastTense: "shared details"
	},
	connectedAt: "You became friends"
}

export const POINTS_NAME: "tickets" | "points" = "tickets"